import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

import editIcon from 'assets/icons/editIcon.svg';
import classes from './BulkEditButton.module.scss';

const BulkEditButton = ({ path }: { path: string }) => {
  const navigate = useNavigate();
  return (
    <Button onClick={() => navigate(path)} className={classes.button}>
      <img src={editIcon} alt="edit" className={classes.btnIcon} />
      <span className={classes.btnTitle}>Bulk Edit</span>
    </Button>
  );
};

export default BulkEditButton;
